import axios from "axios";
import { getCookieToken, getProcessedToken } from "./tokenCheck";
// import { jwtDecode } from "jwt-decode"
import store from "@/store";
const paymentService = axios.create({
	// baseURL: "https://payment.simplifycv.com/", // Dev
	// baseURL: "https://payment.simplifymycareer.com/", // Staging
	baseURL: "https://payment.hire3x.com/", // Production
});

const ServiceCandidate = axios.create({
	// baseURL: "http://localhost:8000/" // Development
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate/", // Staging
		"https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/final/candidate/", // Production
});

const SSOService = axios.create({
	// baseURL: "https://auth.simplifymycareer.com/", // Staging & Development
	baseURL: "https://auth.hire3x.com/" // Production
});

const keyNode = axios.create({
	// baseURL: "https://keynode.simplifycv.com/",
	// baseURL: "https://keynode.simplifymycareer.com/", // Staging
	baseURL: "https://keynode.hire3x.com/", // Production
});

const requestrbac = axios.create({
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac", //development
		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac" // Staging Gateway
		"https://gateway.hire3x.com/rbac/", // Production gateway
});

const recruitmentAPI = axios.create({
	// baseURL: "https://recruitment-api.simplifycv.com",
	// baseURL: "https://recruitment-api.simplifymycareer.com",
	baseURL: "https://recruitment-api.hire3x.com",

});

const notificationAuth = axios.create({
	// baseURL: "https://notification.simplifycv.com/", // Dev Gateway
	baseURL: "https://notification.simplifymycareer.com/", // Staging
	// baseURL: "https://recruitment-api.hire3x.com/", // Production
});

SSOService.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		return error.response;
	}
);

requestrbac.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getCookieToken();
		return config;
	},
	(error) => {
		return error;
	}
);

paymentService.interceptors.request.use(
	(config) => {
		const payload = config.data || {};
		if (payload.createItem) {
			return config;
		}
		config.headers["userID"] = store.getters.adminID;
		return config;
	},
	(error) => {
		return error;
	}
);

paymentService.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		return error.response;
	}
);

ServiceCandidate.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getCookieToken();
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

keyNode.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getCookieToken();
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

notificationAuth.interceptors.request.use(
	(config) => {
		config.headers["userID"] = getProcessedToken();
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

// function getProcessedToken() {

// 	var decoded = jwtDecode(getCookieToken());
// 	console.log(decoded, "decoded");

// 	return decoded.sub;
// }
export {
	paymentService,
	ServiceCandidate,
	SSOService,
	keyNode,
	requestrbac,
	recruitmentAPI,
	notificationAuth
};
